export default __webpack_public_path__ + "static/media/justgivemespace@3x.cd967799.png";